import React, { useRef, Children } from 'react';
import { motion, useInView } from 'framer-motion';
import { TargetIcon, HeartIcon, UsersIcon, BrainIcon } from 'lucide-react';
export function BenefitsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const benefits = [{
    icon: TargetIcon,
    title: 'Dominar los Bloques BAD',
    description: 'Aprenderás a segmentar tu trabajo en micro-climas de 10, 20 y 45 minutos que son "blindados" ante interrupciones.'
  }, {
    icon: HeartIcon,
    title: 'Neutralizar la Culpa',
    description: 'Dejarás de sentir que "ignoras" a tus hijos para trabajar. Aprenderás a darles Conexión de Alta Intensidad para que ellos te den Tiempo de Trabajo de Calidad.'
  }, {
    icon: UsersIcon,
    title: 'Entrenar a tus hijos (y a tu entorno)',
    description: 'Maneras simples de explicar, para que tus hijos entiendan cuándo mamá está en "Modo Túnel" y qué pueden hacer ellos mientras tanto.'
  }, {
    icon: BrainIcon,
    title: 'Limpiar la Carga Mental',
    description: 'Un sistema para que tu negocio avance de forma estratégica, no solo apagando incendios.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section ref={ref} className="w-full bg-[#FDF8F3] py-20 md:py-28" data-id="element-10">
      <div className="max-w-6xl mx-auto px-6" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="text-center mb-16" data-id="element-12">
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-bold text-[#2D2D2D]" data-id="element-13">
            ¿Qué vas a lograr con este Ebook?
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} className="grid md:grid-cols-2 gap-8" data-id="element-14">
          {benefits.map((benefit, index) => <motion.div key={index} variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-sm border border-[#F3EDF7]" data-id="element-15">
              <div className="w-14 h-14 bg-[#F3EDF7] rounded-2xl flex items-center justify-center mb-6" data-id="element-16">
                <benefit.icon className="w-7 h-7 text-[#B794C0]" data-id="element-17" />
              </div>

              <h3 className="font-['Playfair_Display'] text-xl md:text-2xl font-semibold text-[#2D2D2D] mb-4" data-id="element-18">
                {benefit.title}
              </h3>

              <p className="text-[#4A4A4A] leading-relaxed" data-id="element-19">
                {benefit.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}